import React, { FC } from "react";
import { AlertNotification, PatientSettings } from "@shared/models";
import { AlertNotificationRowComponent as AlertAlertNotificationRowComponent } from "@containers/Alert/components/AlertNotificationsListContainer/AlertNotificationsList/AlertNotificationRowComponent";

import "./index.scss";

export interface PatientAlertCardProps {
  alertEvent: AlertNotification;
  onClickMarkAsRead: (alertEvent: AlertNotification) => void;
  patientSettings?: PatientSettings;
}
const PatientAlertCard: FC<PatientAlertCardProps> = (props) => {
  const { alertEvent, patientSettings, onClickMarkAsRead } = props;

  return (
    <div className="patient-alert-card">
      <AlertAlertNotificationRowComponent
        item={alertEvent}
        patientSettings={patientSettings}
        onClickMarkAsRead={onClickMarkAsRead}
      />
    </div>
  );
};

export default PatientAlertCard;
